// src/stone/icons/SecurityShield.tsx
import { jsx } from "react/jsx-runtime";
var SecurityShield = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M11.649 1.064a1 1 0 0 1 .702 0l8 3A1 1 0 0 1 21 5v7c0 3.446-2.282 6.2-4.341 8.003a22.7 22.7 0 0 1-4.104 2.836l-.076.04-.022.01-.006.004h-.002s-.002.001-.449-.893l-.448.894-.003-.001-.006-.004-.022-.01a8 8 0 0 1-.35-.188 22.686 22.686 0 0 1-3.83-2.689C5.281 18.2 3 15.447 3 12V5a1 1 0 0 1 .649-.936zM12 22l-.448.894c.282.14.614.141.895 0zm0-1.137a20.69 20.69 0 0 0 3.342-2.365C17.282 16.8 19 14.553 19 12V5.693l-7-2.625-7 2.625V12c0 2.554 1.718 4.8 3.659 6.497A20.7 20.7 0 0 0 12 20.863" })
  }
);
var SecurityShield_default = SecurityShield;

export {
  SecurityShield,
  SecurityShield_default
};
